import Skeleton from '@mui/material/Skeleton';
import Tooltip from '@mui/material/Tooltip';
import { ExploreTopicDocument } from 'services/types';
import {
  AboutTopicTitle,
  NeedHelpCard,
  NeedHelpContent,
  NeedHelpIcon,
  NeedHelpLink,
  NeedHelpTitle,
  PopularDocDate,
  PopularDocIcon,
  PopularDocItem,
  PopularDocsList,
  PopularDocTitle,
  PopularDocsCard,
} from 'pages/topic-detail/styles';

interface TopicDetailSidebarProps {
  popularDocuments: ExploreTopicDocument[];
  loading?: boolean;
  onSelectDocument: (pageId: string) => void;
}

function TopicDetailSidebar({ popularDocuments, loading = false, onSelectDocument }: Readonly<TopicDetailSidebarProps>) {
  const showPopular = loading || popularDocuments.length > 0;
  return (
    <>
      {showPopular && (
        <PopularDocsCard>
          <AboutTopicTitle>Popular Documents</AboutTopicTitle>
          <PopularDocsList>
            {loading
              ? Array.from({ length: 5 }).map((_, i) => (
                  <PopularDocItem key={i} as="div">
                    <Skeleton variant="rounded" width={22} height={22} />
                    <div style={{ flex: 1 }}>
                      <Skeleton variant="text" width="90%" height={18} />
                      <Skeleton variant="text" width="50%" height={14} />
                    </div>
                  </PopularDocItem>
                ))
              : popularDocuments.map((document) => (
                  <PopularDocItem key={document.id} onClick={() => onSelectDocument(document.id)}>
                    <PopularDocIcon>
                      <img src="/assets/documentation-icon.svg" alt="" width={14} height={14} />
                    </PopularDocIcon>
                    <div>
                      <PopularDocTitle>{document.title}</PopularDocTitle>
                      <PopularDocDate>Updated {document.updatedAt || 'recently'}</PopularDocDate>
                    </div>
                  </PopularDocItem>
                ))}
          </PopularDocsList>
        </PopularDocsCard>
      )}

      <Tooltip title="Coming soon..." arrow>
        <NeedHelpCard>
          <NeedHelpIcon>
            <img src="/assets/chatbot.svg" alt="" width={24} height={24} />
          </NeedHelpIcon>
          <NeedHelpContent>
            <NeedHelpTitle>Still need help?</NeedHelpTitle>
            <NeedHelpLink href="#" onClick={(event) => event.preventDefault()}>
              Talk to Enclave Assistant &rarr;
            </NeedHelpLink>
          </NeedHelpContent>
        </NeedHelpCard>
      </Tooltip>
    </>
  );
}

export default TopicDetailSidebar;
